import { useAppSelector } from 'store/hooks'
import { ClaimsInterface } from 'utils/apiInterfaces'

interface AccessProps {
  action: string
  resource: string
}

const appServices = process.env.REACT_APP_UI_SERVICES

const useCanAccess = (roleAccess: AccessProps) => {
  const claimsData = useAppSelector((state) => state.auth.authData)

  const filteredRoles =
    claimsData?.claims
      .filter(
        (claim: ClaimsInterface) => claim?.resource === roleAccess?.resource
      )[0]
      ?.actions.includes(roleAccess?.action) || false

  return appServices?.includes(roleAccess.resource) && filteredRoles
}

export default useCanAccess
